import { COLORS } from '../leaflet-map.constants';
import { ColorSegments } from '../leaflet-map.types';

export const calculateColorSegments = ({
    unavailableConnectors,
    availableConnectors,
    totalConnectors,
    busyConnectors,
}: Record<string, number>): ColorSegments[] => {
    if (totalConnectors === 0) {
        return [
            { color: COLORS.SUCCESS_GREEN, percentage: 0 },
            { color: COLORS.BRAND_SECONDARY, percentage: 0 },
            { color: COLORS.GREY, percentage: 100 },
        ];
    }

    const availablePercentage = (availableConnectors / totalConnectors) * 100;
    const unavailablePercentage = (unavailableConnectors / totalConnectors) * 100;
    const emptyPercentage = (busyConnectors / totalConnectors) * 100;

    return [
        { color: COLORS.SUCCESS_GREEN, percentage: availablePercentage },
        { color: COLORS.BRAND_SECONDARY, percentage: emptyPercentage },
        { color: COLORS.GREY, percentage: unavailablePercentage },
    ];
};
